var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorexLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 24,
    viewBox: "0 0 112 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Landing"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-24 -22)",
    fill: "#030102"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M91.3008 0.685715H83.6232L94.5335 12L83.6232 23.3143H91.3008L98.9784 15.2327C101.241 12.6466 99.9212 9.84492 98.9784 8.76736L91.3008 0.685715Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.22 0.514286H91.3747L99.1077 8.65438C99.5974 9.214 100.18 10.2138 100.35 11.4101C100.522 12.6138 100.275 14.0119 99.1076 15.3456L99.103 15.3508L91.3747 23.4858H83.22L94.2956 12L83.22 0.514286ZM84.0269 0.857144L94.7719 12L84.0269 23.1429H91.2275L98.8519 15.1172C99.9458 13.8655 100.169 12.5707 100.011 11.4585C99.8517 10.3399 99.3046 9.40133 98.8519 8.88286L91.2275 0.857144H84.0269Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M103.019 8.76736L99.3827 5.13062L103.828 0.685715H111.101L103.019 8.76736Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.757 0.514286H111.515L103.019 9.0098L99.1403 5.13062L103.757 0.514286ZM103.899 0.857144L99.6251 5.13062L103.019 8.52493L110.687 0.857144H103.899Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    d: "M103.424 15.2327L99.7871 18.8694L104.232 23.3143H111.505L103.424 15.2327Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.16 23.4858H111.919L103.423 14.9902L99.544 18.8694L104.16 23.4858ZM104.302 23.1429L100.029 18.8694L103.423 15.4751L111.091 23.1429H104.302Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "corex"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M64.7352 23.5199V0.47995H78.9752V2.27195H66.5752V11.024H77.0552V12.8159H66.5752V21.7279H78.9752V23.5199H64.7352Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M45.5003 23.5199V0.47995H54.1883C54.4123 0.47995 54.6523 0.490617 54.9083 0.51195C55.175 0.522617 55.4523 0.554617 55.7403 0.60795C56.8923 0.789283 57.879 1.20528 58.7003 1.85595C59.5323 2.49595 60.167 3.30662 60.6043 4.28795C61.0416 5.25862 61.2603 6.33062 61.2603 7.50395C61.2603 9.19995 60.807 10.6773 59.9003 11.936C58.9936 13.1946 57.7296 13.9946 56.1083 14.336L55.5803 14.544H47.3403V23.5199H45.5003ZM59.6923 23.5199L55.1483 14.1439L56.8603 13.2799L61.8523 23.5199H59.6923ZM47.3403 12.7359H54.1563C54.3483 12.7359 54.567 12.7253 54.8123 12.7039C55.0683 12.6826 55.3243 12.6506 55.5803 12.608C56.4123 12.4373 57.1056 12.1013 57.6603 11.5999C58.215 11.0879 58.631 10.4746 58.9083 9.75995C59.1856 9.04528 59.3243 8.29328 59.3243 7.50395C59.3243 6.71462 59.1856 5.96795 58.9083 5.26395C58.631 4.54928 58.215 3.94128 57.6603 3.43995C57.1056 2.92795 56.4123 2.58662 55.5803 2.41595C55.3243 2.36262 55.0683 2.32528 54.8123 2.30395C54.567 2.28262 54.3483 2.27195 54.1563 2.27195H47.3403V12.7359Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M32.465 24C30.1716 24 28.2463 23.4933 26.689 22.48C25.1316 21.456 23.9583 20.0427 23.169 18.24C22.3796 16.4373 21.985 14.3573 21.985 12C21.985 9.64267 22.3796 7.56267 23.169 5.76C23.9583 3.95733 25.1316 2.54933 26.689 1.536C28.2463 0.511999 30.1716 0 32.465 0C34.7583 0 36.6783 0.511999 38.225 1.536C39.7823 2.54933 40.9556 3.95733 41.745 5.76C42.5343 7.56267 42.929 9.64267 42.929 12C42.929 14.3573 42.5343 16.4373 41.745 18.24C40.9556 20.0427 39.7823 21.456 38.225 22.48C36.6783 23.4933 34.7583 24 32.465 24ZM32.465 22.192C34.353 22.2027 35.9263 21.776 37.185 20.912C38.4436 20.0373 39.3876 18.832 40.017 17.296C40.6463 15.76 40.961 13.9947 40.961 12C40.961 10.0053 40.6463 8.24 40.017 6.704C39.3876 5.168 38.4436 3.968 37.185 3.104C35.9263 2.24 34.353 1.808 32.465 1.808C30.577 1.79733 29.0036 2.224 27.745 3.088C26.497 3.952 25.5583 5.15733 24.929 6.704C24.2996 8.24 23.9743 10.0053 23.953 12C23.9316 13.9947 24.2356 15.76 24.865 17.296C25.505 18.8213 26.4596 20.0213 27.729 20.896C28.9983 21.76 30.577 22.192 32.465 22.192Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.48 24C8.18667 24 6.26133 23.4933 4.704 22.48C3.14667 21.456 1.97333 20.0427 1.184 18.24C0.394667 16.4373 0 14.3573 0 12C0 9.64267 0.394667 7.56267 1.184 5.76C1.97333 3.95733 3.14667 2.54933 4.704 1.536C6.26133 0.511999 8.18667 0 10.48 0C13.1573 0 15.328 0.693333 16.992 2.08C18.6667 3.46667 19.8027 5.32267 20.4 7.648L18.496 8.112C18.0053 6.18133 17.088 4.65067 15.744 3.52C14.4107 2.37867 12.656 1.808 10.48 1.808C8.592 1.808 7.01867 2.24 5.76 3.104C4.512 3.968 3.568 5.168 2.928 6.704C2.29867 8.24 1.97867 10.0053 1.968 12C1.94667 13.9947 2.25067 15.76 2.88 17.296C3.52 18.8213 4.47467 20.0213 5.744 20.896C7.01333 21.76 8.592 22.192 10.48 22.192C12.656 22.192 14.4107 21.6213 15.744 20.48C17.088 19.3387 18.0053 17.808 18.496 15.888L20.4 16.352C19.8027 18.6773 18.6667 20.5333 16.992 21.92C15.328 23.3067 13.1573 24 10.48 24Z",
    fill: "#FAFAFA"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorexLogo);
export default __webpack_public_path__ + "static/media/corex-logo.0e1172555bf08e77de192bb580784d2e.svg";
export { ForwardRef as ReactComponent };